import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
} from '@/shared/shadcn/components/breadcrumb';
import { Separator } from '@/shared/shadcn/components/separator';
import { SidebarInset, SidebarProvider, SidebarTrigger } from '@/shared/shadcn/components/sidebar';
import { AppSidebar } from '@/components/admin/navigation/AppSidebar';
import { Toaster } from '@/shared/shadcn/components/toaster';
import React from 'react';
import { ROUTES } from '@/constants/routes';
import { useRouter } from 'next/router';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout = ({ children }: AdminLayoutProps): JSX.Element => {
  const router = useRouter();
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="flex h-16 shrink-0 items-center gap-2">
          <div className="flex items-center gap-2 px-4">
            <SidebarTrigger className="-ml-1" />
            <Separator orientation="vertical" className="mr-2 h-4" />
            <Breadcrumb>
              <BreadcrumbList>
                <BreadcrumbItem>
                  <BreadcrumbLink
                    onClick={() =>
                      router.push(ROUTES.ADMIN.PROJECTS.route, ROUTES.ADMIN.PROJECTS.url)
                    }
                    href="#"
                  >
                    MINERVA Admin
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          </div>
        </header>
        <div className="flex flex-1 flex-col gap-4 p-4 pt-0">{children}</div>
      </SidebarInset>
      <Toaster />
    </SidebarProvider>
  );
};

export default AdminLayout;
